import { IOtherAppointmentSlot } from "@/models";

interface IOtherAppointmentState {
    otherApointments: IOtherAppointmentSlot[];
    selectedOtherAppointment: IOtherAppointmentSlot;
}

const initialState: IOtherAppointmentState = {
    otherApointments: [],
    selectedOtherAppointment: null,
};

export { IOtherAppointmentState, initialState };
